import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { AlertComponent } from 'src/app/pages/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-exam-list',
  templateUrl: './exam-list.component.html',
  styleUrls: ['./exam-list.component.scss']
})
export class ExamListComponent {
  public isSpinnerLoading: boolean = false;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public displayedColumns: string[] = ['no', 'title', 'total_que', 'right_answer', 'attend_date', 'status', 'action'];
  public dataSource = new MatTableDataSource();
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public count!: any;
  public maxPaginationSize = GlobalService.maxPaginationSize;
  public courseData: any;
  public manualCertificateGeneration: any;
  public examResultInfo: any;
  public getParams;
  public imageURL: string = GlobalService.imageURL
  @Input() listData: any;
  @Output() childEvent = new EventEmitter<any>();
  
  constructor(private _liveAnnouncer: LiveAnnouncer, private indvidualService: IndividualService, private router: Router, private activatedRoute: ActivatedRoute,
    private appService: AppService, private commonService: CommonService, public dialog:MatDialog
    ) { }

  ngOnInit(): void {
    this.commonService.setTitle("Courses")
   
    this.getParams = this.listData
    this.getList()
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    // this.noticesList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    // this.noticesList()
  }
  getList() {
    let data={
      c_i:this.getParams.c_i,
      p_i:this.getParams.p_i,
      t:this.getParams.t
    }
    this.isSpinnerLoading=true
    this.indvidualService.getExamList(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.isSpinnerLoading=false;
          this.count=success.data.count
          if(success.data.exam_list.length){
            let firstUnttended = 0
            for (const key in success.data.exam_list) {
              if (Object.prototype.hasOwnProperty.call(success.data.exam_list, key)) {
                const element = success.data.exam_list[key];
                if (element.is_att == 0) {
                  element.isShowAttend = 0;
                  if (firstUnttended == 0) {
                    firstUnttended = 1;
                    element.isShowAttend = 1;
                  }
                }
              }
            }
              for (const key in success.data.exam_list) {
                if (Object.prototype.hasOwnProperty.call(success.data.exam_list, key)) {
                  const element = success.data.exam_list[key];
                  if (element.is_atted == 0) {
                    this.onAttendExam(element.e_i);
                  }
                }
              }
          }
          else{

          }
          this.courseData = success.data.course_info;
          this.examResultInfo = success.data.exam_result;
          this.manualCertificateGeneration = success.data.m_c_g.m_c_g;
          this.dataSource = new MatTableDataSource(success.data.exam_list);
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading=false;
        this.commonService.handleError(error)
      }
    }
    );
  }
  onAttendExam(id: string) {
    let data = {
      c_i: this.getParams.c_i,
      p_i: this.getParams.p_i,
      e_i: id,
      e_t: "f",
      type: "exam_pending"
    }
    this.childEvent.emit(data)
    // this.router.navigate(['/individual/my-course/exam'], { queryParams: data });
  }
  onExamAlertPopup(value: any) {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: 'exam_alert', }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
  
      }
    });
   }
  download(examSheet) {
    this.appService.downloadFile(examSheet, 'exam_sheet')
  }
  onResetExamClick() {
    this.isSpinnerLoading = true;
    let data={
      c_i:this.getParams.c_i, 
      p_i:this.getParams.p_i,
      t:this.getParams.t
    }
    this.indvidualService.manageExamReset(data).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.getList();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }
    );
  }
  isAllSubSectionCompleted(arr: any[], clickedIndex: number): boolean {
    // Check if the clicked index is the last element in the array
    // if (clickedIndex === arr.length - 1) {
      // Check if all previous objects have is_completed set to true
      for (let i = 0; i < clickedIndex; i++) {
        if (!arr[i].sub_section_arr || !arr[i].sub_section_arr.every((sub) => sub.is_completed === 1)) {
          return false;
        }
      }
      // If all previous objects have is_completed set to true, return true
      return true;
    // }
    // If the clicked index is not the last element, return false
    // return false;
  }
}
